module.exports = __webpack_public_path__ + "static/media/create_reservation_select_desk.86b063da.jpg";